import {IconProps} from './types';

function ViewToggle({stroke = 'black'}: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect x="0.5" y="0.5" width="15" height="15" rx="4.5" stroke={stroke} strokeWidth="1"/>
            <line y1="5.26001" x2="16" y2="5.26001" stroke={stroke} strokeWidth="1"/>
            <line y1="10.7" x2="16" y2="10.7" stroke={stroke} strokeWidth="1"/>
        </svg>
    );
}

export default ViewToggle;
